import { render, staticRenderFns } from "./MapLink.vue?vue&type=template&id=64d0b175&scoped=true&"
import script from "./MapLink.vue?vue&type=script&lang=js&"
export * from "./MapLink.vue?vue&type=script&lang=js&"
import style0 from "./MapLink.vue?vue&type=style&index=0&id=64d0b175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0b175",
  null
  
)

export default component.exports